import $ from 'jquery';

class Toast {
  constructor(data) {
    // Protected
    const dataTypes = ['info'];
    const timeout = parseInt(data.timeout) ? parseInt(data.timeout) : 5000;

    // Create element and body
    this.toast = $('<div />', { class: 'toast' });
    $('<p />', { class: 'toast__body', text: data.body }).appendTo(this.toast);

    // Add icon, if exists
    if (dataTypes.includes(data.type)) {
      this.toast.addClass(`toast--${data.type}`);
    } else {
      this.toast.addClass('toast--info');
    }

    // Add toast to body
    $('body').append(this.toast);

    // Start timer
    this.timer(timeout);
  }

  show() {
    this.toast.addClass('toast--visible');
  }

  hide() {
    this.toast.removeClass('toast--visible');
    setTimeout(() => {
      this.toast.remove();
    }, 200);
  }

  timer(timeout) {
    setTimeout(() => {
      this.hide();
    }, timeout);
  }
}

const toast = (data) => new Toast(data);

export default toast;
